import { openDrawer } from "@/src/components/dialogs";
import { Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  getServiceId,
  getUserId,
  isBureauAdmission,
  isReception,
  uid,
} from "@/src/utils/utils";
import { useState } from "react";
import { FaRegFolderOpen } from "react-icons/fa";
import { hasPermission } from "../../utils/utils";
import { AntecedentsCompartment } from "./antecedentsHistory";

import { Button } from "@/src/components/buttons";
import { Input } from "@/src/components/universalInput";
import { USER } from "@/src/data/globalVariables";
import { AppointmentsHistory } from "./appointmentsHistory";
import { hasAccessToPatient } from "./confidentialitiesHook";
import { DocumentsHistory } from "./documentsHistory";
import { PatientHistory } from "./patientHistory";
import { PatientIdentity } from "./patientIdentity";
import { MedecineLegaleDashboardUnits } from "./patientMedecineLegale";
import { HospitalisationsHistory } from "./hospitalisationsHistory";
import { BureauAdmissionsHospitalisationsHistory } from "./bureauAdmissionsHospitalisationsHistory";
import { DiagnosticsCompartment } from "../hospitalisation/diagnosticsCompartment";

function PatientDashboard({
  currentPatient,
  onChange,
  historyType,
  onHistoryTypeChange,
}: {
  currentPatient: Patient;
  onChange?: (newValue: Patient) => void;
  historyType?: string | null | undefined;
  onHistoryTypeChange?: (newValue: string) => void;
}) {
  const [patient, setPatient] = useState(currentPatient);

  if (!hasAccessToPatient(patient))
    return (
      <div className=" center tcenter" style={{ height: "100%" }}>
        <div className="c1 gap10 tcenter" style={{ opacity: "0.8" }}>
          <div>
            <FaRegFolderOpen size={60} />
          </div>
          <div className="bold ">
            Ce patient ne figure pas encore sur votre liste
          </div>
          <div className="gray">
            En ajoutant ce patient à votre liste, vous n&apos;aurez accès
            qu&apos;aux éléments du dossier dont vous avez l&apos;autorisation
          </div>
          <div className="center">
            <Button
              onClick={async () => {
                let birthDate: string = patient.birth || "";
                await openDrawer({
                  id: "patientVerificationDrawer",
                  title: "Confirmer la date de naissance",
                  content: (
                    <div>
                      <Input
                        name="Date de naissance"
                        type="date"
                        isRequired={true}
                        value={birthDate}
                        onBlur={(newValue) => {
                          birthDate = newValue;
                        }}
                        onChange={(newValue) => {
                          birthDate = newValue;
                        }}
                      ></Input>
                    </div>
                  ),
                  onConfirm: async () => {
                    if (birthDate != patient.birth)
                      throw Error(
                        "Date de naissance incorrecte.\n\n Veuillez utiliser une date de naissance correcte pour le patient, ou créer un nouveau dossier."
                      );

                    let newPatient = await apiFetch(
                      "patients",
                      "addServiceAccessToPatient",
                      {
                        patientId: patient.id,
                        serviceId: getServiceId(),
                        userId: getUserId(),
                      }
                    );

                    patient.services = newPatient.services;
                    setPatient({ ...patient });
                  },
                });
              }}
            >
              Ajouter le patient à ma liste
            </Button>
          </div>
        </div>
      </div>
    );

  return (
    <div id="patient_dashboard">
      <div className="grid mc1 gap20">
        <PatientIdentity
          patient={patient}
          onChange={(newValue) => {
            onChange?.(newValue);
            setPatient(newValue);
          }}
        ></PatientIdentity>
        {USER.get()?.speciality?.name?.includes("oncolo") == true && (
          <div>
            <DiagnosticsCompartment
              parent={null}
              patient={patient}
            ></DiagnosticsCompartment>
          </div>
        )}
        {/* {hasPermission( "antecedents") && ( */}
        {!isReception(USER.get()) && !isBureauAdmission(USER.get()) && (
          <div className="double msingle">
            <AntecedentsCompartment
              patient={patient}
              // color="red"
            ></AntecedentsCompartment>
          </div>
        )}
        {/* )} */}
        {hasPermission("admissionDocuments") && (
          <div className="double">
            <DocumentsHistory
              patient={patient}
              parent={null}
            ></DocumentsHistory>
          </div>
        )}
        
        {isReception(USER.get()) && (
          <div className="double">
            <AppointmentsHistory
              title="Rendez-vous"
              patient={patient}
              types={null}
            ></AppointmentsHistory>
          </div>
        )}
        {isBureauAdmission(USER.get()) && (
          <div className="double">
            <BureauAdmissionsHospitalisationsHistory
              patient={patient}
            ></BureauAdmissionsHospitalisationsHistory>
          </div>
        )}
      </div>
      <MedecineLegaleDashboardUnits
        patient={patient}
      ></MedecineLegaleDashboardUnits>
      {!isReception(USER.get()) &&
        !isBureauAdmission(USER.get()) &&
        !USER?.get()?.service?.name?.toLowerCase()?.includes("légal") && (
          <PatientHistory
            patient={patient}
            historyType={historyType}
            onHistoryTypeChange={onHistoryTypeChange}
          ></PatientHistory>
        )}
    </div>
  );
}

async function openPatientDashboard(
  patient: Patient | null | undefined,
  onChange?: (newValue: Patient) => void
) {
  if (!patient) throw new Error("Aucun patient trouvé");
  await openDrawer({
    id: "patientDashboardDrawer",
    additionalClasses: ["big"],
    title: "Dossier patient",
    content: (
      <PatientDashboard
        key={uid()}
        currentPatient={patient}
        onChange={onChange}
      ></PatientDashboard>
    ),
  });
}

export { openPatientDashboard, PatientDashboard };
